import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import styles from './TraderDashboard.module.css';

const HistoryTableRow = ({ run, formatValue }) => (
  <tr>
    <td>{run.run_name || 'System Run'}</td>
    <td>{new Date(run.created_at).toLocaleDateString()}</td>
    <td>{formatValue(run.metrics?.total_return, true)}</td>
    <td>{formatValue(run.metrics?.max_drawdown, true)}</td>
    <td>
      <Link to={`/backtest/details/${run.id || run.run_id}`} className={styles.viewLink}>
        View Details
      </Link>
    </td>
  </tr>
);

HistoryTableRow.propTypes = {
  run: PropTypes.shape({
    id: PropTypes.string,
    run_id: PropTypes.string,
    run_name: PropTypes.string,
    created_at: PropTypes.string,
    metrics: PropTypes.shape({
      total_return: PropTypes.number,
      max_drawdown: PropTypes.number,
    }),
  }).isRequired,
  formatValue: PropTypes.func.isRequired,
};

const HistoryTable = ({ 
  backtestHistory, 
  historyLoading, 
  formatValue 
}) => {
  if (historyLoading && backtestHistory.length === 0) {
    return (
      <div className={styles.loadingState}>
        <FontAwesomeIcon icon={faSpinner} spin /> Loading history...
      </div>
    );
  }

  if (backtestHistory.length === 0) {
    return (
      <div className={styles.emptyState}>
        No backtest history found. Run your first backtest!
      </div>
    );
  }

  return (
    <table className={styles.historyTable}>
      <thead>
        <tr>
          <th>Run Name</th>
          <th>Date</th>
          <th>Total Return</th>
          <th>Max Drawdown</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {backtestHistory.map((run) => (
          <HistoryTableRow 
            key={run.id || run.run_id} 
            run={run} 
            formatValue={formatValue} 
          />
        ))}
      </tbody>
    </table>
  );
};

HistoryTable.propTypes = {
  backtestHistory: PropTypes.array.isRequired,
  historyLoading: PropTypes.bool.isRequired,
  formatValue: PropTypes.func.isRequired,
};

export default HistoryTable;